let mapInstance = null;

window.GMap = class {
  constructor (id, isStatic) {
    this.isStatic = isStatic;

    let div, map;
    const $gmap = $(`#${id}`);

    let polylineOptions = false

    let partner = $('body').attr('class').match(/gmap-pins-([a-z0-9\-_]+)/)

    if (partner) {
      partner = partner[1]
      polylineOptions = {
        strokeColor: $gmap.css('color')
      }
    }

    const pinPath = direction => ({
      url: `/img/svg/map_pin_${direction}_${partner || 'default'}.svg`,
      scaledSize: new google.maps.Size(40, 40)
    });

    this.markers = {
      from: { marker: null, icon: pinPath('from') },
      to: { marker: null, icon: pinPath('to') },
      carrier: { marker: null },
    }

    if (mapInstance) {
      ({ div, map } = mapInstance);
    } else {
      div = document.createElement('div');
      map = new google.maps.Map(div);
      mapInstance = { div, map };
    }

    this.map = map;

    // Clear tabindex
    this.map.addListener('tilesloaded', function () {
      $gmap.find('a, area').attr('tabindex', -1);
    });

    this.setOptions();

    this.flightRoute = new google.maps.Polyline();

    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      suppressInfoWindows: true,
      preserveViewport: true,
      polylineOptions
    });

    // can be overrided
    this.updatedMarkerPosition = function (key, pos) {
      console.log('marker position updated', key, pos);
    }

    $gmap.append(div);
  }

  setOptions () {
    this.map.setOptions({
      zoom: 3,
      center: {
        lat: 55.755826,
        lng: 37.6173
      },
      mapTypeControl: false,
      streetViewControl: false
    });
  }

  setMarker (key, position) {
    this.clearMarker(key)
    if (position) {
      let latLng = new google.maps.LatLng(position[0], position[1])
      this.markers[key].marker = new google.maps.Marker({
        position: latLng,
        optimized: false,
        icon: this.markers[key].icon
      })
      this.markers[key].marker.setMap(this.map)
      if (!Functions.isMobileDevice() && !this.isStatic) {
        this.markers[key].marker.setDraggable(true)
        this.markers[key].marker.addListener('dragend', this.dragendMarker(key))
      }
    }
    this.zoomMarker()
  }

  dragendMarker (key) {
    return () => {
      let position = this.markers[key].marker.position
      this.updatedMarkerPosition(key, position)
      this.zoomMarker()
    }
  }

  clearAllMarkers () {
    for (const key in this.markers) {
      this.clearMarker(key);
    }
  }

  clearMarker (key) {
    let marker = this.markers[key].marker
    if (marker) {
      marker.setMap(null)
      this.markers[key].marker = null
    }
  }

  zoomMarker () {
    let bounds = new google.maps.LatLngBounds()
    let count = 0
    let marker, existingMarker
    for (let key in this.markers) {
      marker = this.markers[key].marker
      if (marker) {
        bounds.extend(marker.getPosition())
        existingMarker = marker
        count++
      }
    }

    if (count === 0) return;

    if (count === 1) {
      this.map.setCenter(existingMarker.getPosition())
      this.map.setZoom(16)
    }

    if (count > 1) this.map.fitBounds(bounds);
  }

  setRoute (routeSteps) {
    if (!routeSteps.routes) return
    this.directionsRenderer.setDirections(routeSteps)
    this.directionsRenderer.setMap(this.map)
  }

  clearRoute () {
    this.flightRoute.setMap(null)
    this.directionsRenderer.setMap(null)
    this.zoomMarker()
  }

  setCarrierMarker (position) {
    const keyOfCarrierMarker = 'carrier';

    this.clearMarker(keyOfCarrierMarker);

    this.markers[keyOfCarrierMarker].marker = new google.maps.Marker({
      position: new google.maps.LatLng(position[0], position[1]),
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8.5,
        fillColor: '#ff6900',
        fillOpacity: 1,
        strokeWeight: 0.4
      }
    });

    this.markers[keyOfCarrierMarker].marker.setMap(this.map);
  }

  destroy () {
    this.clearRoute();
    this.clearAllMarkers();
    this.setOptions();
    google.maps.event.clearListeners(this.map, 'tilesloaded');
  }
}
